export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6425.d5d19a6d.jpg";